import {Validator} from 'vee-validate'
import { firstCharUpper } from '../../lib/firstCharUpper'

const dictionary = {
  zh: {
    attributes: {
      email: '邮箱',
      confirm: '确认密码',
      password: '密码',
      newPassword: '新密码',
      phone: '手机号',
      verificationCode: '验证码',
      invitationCode: '邀请码',
      dialCode: '区号',
      callingCode: '区号',
      name: '持卡人姓名',
      account: '账号',
      captcha: '图形验证码',
      promotionPlatform: '推广平台',
      promotionMethod: '推广方式',
      companyName: '公司名称'
    },
    messages: {
      email: (field) => field + '格式错误',
      required: (field) => '请输入' + field,
      confirmed: (field) => field + '内容不匹配',
      max: (field, [length]) => field + '不能大于' + length + '个字符',
      min: (field, [length]) => field + '不能小于' + length + '个字符',
      alpha_dash: (field) => field + '只能包含英文字母、数字、减号、下划线',
      numeric: (field) => field + '只能包含数字字符',
      digits: (field, [length]) => field + '只能为' + length + '位数字'
    }
  },
  en: {
    attributes: {
      newPassword: 'new password',
      invitationCode: 'invitation code',
      dialCode: 'calling code',
      callingCode: 'calling code',
      promotionPlatform: 'promotion platform',
      promotionMethod: 'promotion method',
      companyName: 'company name'
    },
    messages: {
      required: (field) => 'Please enter ' + field,
      max: (field, [length]) => 'The ' + field + ' must not be greater than ' + length + ' characters',
      min: (field, [length]) => 'The ' + field + ' must be at least ' + length + ' characters',
      digits: (field, [length]) => 'The ' + field + ' can only be ' + length + ' digits'
    }
  }
}
Validator.updateDictionary(dictionary)



// WEBPACK FOOTER //
// ./src/assets/js/myValidationRules.js